var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['dashboard-button', { 'is-requesting': _vm.isRequesting }],attrs:{"disabled":_vm.isRequesting || _vm.invalid},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[(_vm.isRequesting)?_c('spinner',{attrs:{"width":24,"height":24}}):_c('label',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }